import { http } from "../http";
import { GroupModal } from "@/facilities/model/user";

export const addGroup = async (params: GroupModal) => {
  return await http.post("/api/group", params);
};

export const deleleGroup = async (ids: string[]) => {
  return await http.put("/api/group/remove", { ids });
};

export const getGroupLists = async (params?: GroupModal) => {
  return await http.get("/api/group/page", { params });
};

// 编辑
export const eidtGroup = async (params: GroupModal) => {
  return await http.put("/api/group", params);
};

export const getGroupPermiss = async (id?: string) => {
  return await http.get(`/api/group/permissions/${id}`);
};

// 添加用户到组
export const addUserToGroup = async (userIds: string[], groupId: string) => {
  return await http.post("/api/group/user", { userIds, groupId });
};

// 移除用户
export const removeUserInGroup = async (userIds: string[], groupId: string) => {
  return await http.put("/api/group/user", { userIds, groupId });
};
